import React from "react";

type Props = {
  message: string;
};

const DataNotAvailableMessage: React.FC<Props> = ({ message }) => {
  return (
    <div className="flex min-h-12 items-center justify-center rounded-lg bg-bg-secondary px-3 py-2 text-center text-s-v4 text-text-tertiary">
      {message}
    </div>
  );
};

export default DataNotAvailableMessage;
